import { yupResolver } from '@hookform/resolvers/yup';
import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import TextFieldComponent from '../../components/inputs/Textfield/TextfieldComponent';
import { routes } from '../../routes';
import { createScientificArea } from '../../services/school/scientificArea/createScientificArea';
import { CreateScientificAreaType } from '../../types/ScientificAreas';
import { CreateScientificAreaFormValidation } from './CreateScientificAreaFormValidation';
import { useGetKnowledgeDomainsQuery } from '../../hooks/useGetKnowledgeDomainsQuery';
import { useGetKnowledgeSubDomainsQuery } from '../../hooks/useGetKnowledgeSubDomainsQuery';
import { isEmpty } from 'lodash';
import SelectComponent from '../../components/inputs/Select/SelectComponent';

export default function CreateScientificArea() {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createScientificArea, mutationKey: 'createScientificArea' });

  const defaultValues: CreateScientificAreaType = {
    description: ''
  }
  const { control, handleSubmit, setValue, getValues, formState: { errors } ,resetField} = useForm<CreateScientificAreaType>({
    resolver: yupResolver(CreateScientificAreaFormValidation),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Área cientifica criada");
        navigate(routes.scientificAreas);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
 const { data: domains, isLoading: isLoadingDomains, isError: errorDomains } = useGetKnowledgeDomainsQuery({ PageNumber: 1, PageSize: 400 });
  const { data: subDomains, isLoading: isLoadingSubDomains, isError: errorSubDomains, refetch: refreshSubDomains } = useGetKnowledgeSubDomainsQuery(
    { PageNumber: 1, PageSize: 400, DomainId: getValues('idKnowledgeDomain') },
    { enabled: !!getValues('idKnowledgeDomain') }
  );
  const handleBack = () => {
    navigate(routes.scientificAreas);
  }
    const handleKnowledgeDomainChange = (id: string) => {
      setValue('idKnowledgeDomain', id);
      if(isEmpty(id)){
        resetField('idKnowledgeSubDomain')
        return;
      }
      refreshSubDomains();
    };
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
            <TextFieldComponent name="description" label='Descrição' control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
            <Flex gap='4'>
            <SelectComponent
              name="idKnowledgeDomain"
              label="Domínio de Conhecimento"
              control={control}
              errors={errors}
              style={{ width: '100%' }}
              options={domains?.items.map(domain => ({
                value: domain.id ?? "",
                label: domain.description ?? ""
              }))}
              itemsLoading={isLoadingDomains}
              itemsError={errorDomains}
              onSelect={handleKnowledgeDomainChange}

            />
            <SelectComponent
              name="idKnowledgeSubDomain"
              label="SubDomínio de Conhecimento"
              control={control}
              errors={errors}
              style={{ width: '100%' }}
              options={subDomains?.items.map(domain => ({
                value: domain.id ?? "",
                label: domain.description ?? ""
              }))}
              itemsLoading={isLoadingSubDomains}
              itemsError={errorSubDomains}
            />
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant='surface'>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}